<template>
<div style="background-color:#e0f2f1;margin-top:10px">
  <!-- <div style="padding-top:-10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">Testimonials</span></p>
     </div> -->
      <div class="kolkata5 res">
         <v-layout row wrap class="">
            <v-flex xs12 sm12 md6 lg12 style="text-align:center">
                 <h1 style="padding:25px;color:whitesmoke;">Student Testimonials</h1>
            </v-flex>
         </v-layout>
     </div>
      <div class="kolkata5 man">
          <v-layout row wrap class="container" style="margin-top:50px">
              <v-flex xs12 sm12 md6 lg12 >
                  <h1 style="padding:15px;color:whitesmoke;">Student Testimonials</h1>
              </v-flex>
          </v-layout>
      </div>
    <v-card flat>
        <v-container>
            <!-- <v-tabs
      v-model="tab"
      color="red"
      grow
      dark
    >
    <v-tab><h5>Student Feedback</h5></v-tab>
    <v-tab><h5>Shared Image Feedback</h5></v-tab>
    </v-tabs> -->

    <v-container v-if="studentList.length>0">
      <v-layout row wrap>

      <v-flex xs12 sm12 md8 >

             <div class="row" style="margin:0px;">
               <div class="col-lg-6 col-sm-12 col-md-6" v-for="owl in studentList" :key="owl.id">
              <v-card style="background-color:#ff9000 ;height: 500px;">
                <v-container>
                  <div style="height:200px;padding: 10px;">
                  <p style="font-size:16px; " v-html="owl.description" class="txt"></p>
                </div>
              <v-card-title>
                <v-avatar>
                  <img :src=owl.src />
                </v-avatar>&nbsp;&nbsp;<h4 style="margin-top:30px">{{owl.name}}
                  <p style="color:#1877F2;font-size:16px">({{owl.address}})</p>
                </h4>
                <p style="color:white;margin-top:-10px;font-size:14px;">{{owl.courseName}}
                </p>
              </v-card-title>
              <div style="margin-top:5px;">
                <div class="row">
                  <div class="col-4">
                    <img style="height:40px;width:50px; margin-right: 10px;"  :src=owl.countrySrc />
                    <p style="font-size:14px;font-weight: bold;padding-top:5px;">{{owl.countryName}}
                    </p>
                 </div>
                 <div class="col-8" style="text-align:right;">
                    <img style="height:40px;width:70px;" :src=owl.universitySrc />
                    <p style="font-size:14px;font-weight: bold;padding-top:5px;">{{owl.universityName}}
                    </p>
                 </div>
                </div>
              </div>
              </v-container>
              </v-card>
            </div>
             </div>
            </v-flex>
            <v-flex xs12 sm12 md4 >
        <div class="container" style="padding-top:25px;">

          <div class="row">
            <div class="col-lg-12 col-md-12" style="text-align: center;padding-bottom: 15px;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/t9geaUKy5vI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-12 col-md-12" style="text-align: center;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/RADBic9ne_M" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-12 col-md-12" style="text-align: center;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/OHNoqW3gVcs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-12 col-md-12" style="text-align: center;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/gnHwF1J4xJ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>

             <v-divider></v-divider>
             <div class="row" style="margin:0px;">
                <div class="col-lg-4 col-md-4 col-sm-12" style="padding: 10px;" v-for="item in imageList" :key="item.id" >
                    <img style="height: 200px;width: 100%;" :src=item.src />
                </div>
            </div>
        </v-container>

    <!-- <v-tabs-items v-model="tab">
        <v-tab-item style="background-color:white">
            
        </v-tab-item>

        <v-tab-item style="background-color:white">
            <div class="row" style="margin:0px;">
                <div class="col-lg-4 col-md-4 col-sm-12" style="padding: 10px;" v-for="item in imageList" :key="item.id" >
                    <img style="height: 200px;width: 100%;" :src=item.src />
                </div>
            </div>
        </v-tab-item>
    </v-tabs-items> -->
        </v-container>
    </v-card>
</div>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
export default {
    components: {
    //GoTop,
    carousel,
  },
  data() {
    return {
      valid: true,
      tab: null,
      isLoading: false,
      news: {},
      imageList: [],
      studentList: []
    };
  },

  methods: {
    home(){
        this.$router.push(`/worldwin`);
    },
  },

  mounted() {
      this.axios
        .get(config.API + "testimonial/authors", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          let list = res.data.authors;

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            if(element.src != null && element.type=='text') {
          this.studentList.push({
            id: element.id,
            name: element.name,
            address: element.address,
            description: element.description,
            courseName: element.course.courseName,
            universitySrc: config.API1 + 'university/files/' + element.university.src,
            countrySrc: config.API1 + 'country/files/' + element.university.country.src,
            countryName: element.university.country.countryName,
            universityName: element.university.universityName,
            src: config.API1 + "testimonial/files/" + element.src
          })
        }

        if(element.src != null && element.type=='image') {
          this.imageList.push({
            id: element.id,
            name: element.name,
            address: element.address,
            description: element.description,
            src: config.API1 + "testimonial/files/" + element.src
          })
        }
          }
        })
        .catch(() => {
          this.$Progress.fail();
        });
  }
};
</script>

<style lang="css" scoped>
img.center {
    display: block;
    margin: 0 auto;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('http://www.royalacpaints.com/images/about-us-banner.jpg');
    background-size: cover;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
.mobile-heading {
  font-size: 30px;
}
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>
